"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IncludeJavaScript = IncludeJavaScript;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

/**
 * Include javascript file, the callback will be called when it finished loading
 *
 * @export func
 * @param {any} jsFilePath - src path to include
 * @param {any} elementId - element id to make sure its only included once
 * @param {any} callback - callback when its finished loading, args: false = error, true = success
 */
function IncludeJavaScript(jsFilePath, elementId, callback, onerror, attributes) {
  if (document.getElementById(elementId)) {
    // element with this id allready exists
    return;
  }

  var js = document.createElement('script');
  js.id = elementId;
  js.type = 'text/javascript';
  js.async = true;
  js.src = jsFilePath;

  if ((0, _typeof2["default"])(attributes) === 'object' && !Array.isArray(attributes)) {
    for (var key in attributes) {
      js.setAttribute(key, attributes[key]);
    }
  }

  js.onerror = function () {
    if (onerror) {
      onerror(new Error('Error loading resource'));
    }
  };

  js.onload = function () {
    if (callback) {
      callback();
    }
  };

  document.body.appendChild(js);
}